import API from "../app/api";

export const GetAddonItems = async () => {
    try {
        const { data } = await API.get("/product-others/add-ons");

        if (!data?.success) {
            throw new Error(data?.message || "Failed to fetch add-ons");
        }

        return data?.data || [];
    } catch (error) {
        // Handle axios error properly
        const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong while fetching add-ons";

        throw new Error(errorMessage);
    }
};